import { observable, action, makeObservable } from 'mobx'
import { persist } from 'mobx-persist'
import { SubjectType } from './weeklyInfoTypes'

class NoteCache {
  @persist('list')
  @observable
  Management: string[] = []
  @persist('list')
  @observable
  Restaurant: string[] = []
  @persist('list')
  @observable
  Kitchen: string[] = []
  @persist('list')
  @observable
  Market: string[] = []
}

class NoteStore {
  constructor() {
    makeObservable(this)
  }

  @persist('object', NoteCache)
  @observable
  notes: NoteCache = new NoteCache()

  @action
  addNewNote = (note: string, section: SubjectType) => {
    this.notes[section].push(note)
  }

  @action
  deleteNote = (index: number, section: SubjectType) => {
    this.notes[section].splice(index, 1)
  }
}

export default new NoteStore()
